import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import DayPicker, { DateUtils } from 'react-day-picker';
import moment from 'moment-timezone';
import { ButtonGroupToggle } from '../../widgets';
import { API_DATETIME_FORMAT, DISPLAY_DATE_FORMAT2 } from '../../../constants';
import 'react-day-picker/lib/style.css';
import "../../../../assets/scss/multiselect-datepicker.scss";

export const RangeSelection = ({ timezone, onChange, defaultRange, searchParams,
    calendar: { defaultDate, enabledDate, maxSelectDays }, recentSummary: { replayBox:
        { data: { start_date: replay_start_date, end_date: replay_end_date }, search_id },
        workWindow: { show: workWindowShow, range:
            { start_date: workwindow_start_date, end_date: workwindow_end_date } } } }) => {

    const getInitialDate = () => ({ start: undefined, end: undefined });
    const [showCalendar, toggleCalendar] = useState(false);
    const [range, setRange] = useState(defaultRange);
    const [pickerDate, setPickerDate] = useState(defaultDate || getInitialDate());
    const [isInitialLoad, setInitialLoad] = useState(true);

    const setDateRange = (selectedRange, isInitial = false) => {
        if (isInitialLoad) { setInitialLoad(false); return; }
        const date = { start: null, end: null };

        if (selectedRange === 1) {
            const today = moment.utc().tz(timezone).format(API_DATETIME_FORMAT);
            date.start = moment.utc(today).startOf("day");
            date.end = moment.utc(today).endOf("day");
        }
        else if (selectedRange === 2) {
            const today = moment.utc().tz(timezone).format(API_DATETIME_FORMAT);
            date.start = moment.utc(today).startOf('day').subtract(1, 'day');
            date.end = date.start.clone().endOf("day");
        }
        else if (selectedRange === 3 && pickerDate.start && pickerDate.end) {
            date.start = pickerDate.start;
            date.end = pickerDate.end;
        }

        onChange(selectedRange, date, isInitial);
        setRange(selectedRange);
    };

    const handleRangeSelect = selectedRange => {
        if (selectedRange === 3 && range === selectedRange) {
            if (showCalendar) onChange(selectedRange, pickerDate);
            return toggleCalendar(!showCalendar);
        }
        setDateRange(selectedRange);
        toggleCalendar(selectedRange === 3 ? !showCalendar : false);
    };

    useEffect(() => syncSearchParamDate(), [searchParams]);

    useEffect(() => {
        if (!workwindow_start_date && search_id && replay_start_date) {
            recentSummaryDate(replay_start_date, replay_end_date)
        }
    }, [search_id]);

    useEffect(() => {
        if (!search_id && workWindowShow && workwindow_start_date) {
            recentSummaryDate(workwindow_start_date, workwindow_end_date);
        }
    }, [workWindowShow, workwindow_start_date]);

    useEffect(() => {
        setInitialLoad(true);
        if (search_id && replay_start_date && replay_end_date) recentSummaryDate(replay_start_date, replay_end_date);
        else if (workWindowShow && workwindow_start_date && workwindow_end_date) recentSummaryDate(workwindow_start_date, workwindow_end_date);
        else syncSearchParamDate();
    }, []);

    useEffect(() => setDateRange(defaultRange, false), [defaultRange]);

    useEffect(() => {
        if (enabledDate && enabledDate.start && enabledDate.end) {
            const start = moment(enabledDate.start);
            const end = moment(enabledDate.end);

            let dateRange = {};
            if (end.diff(start, "days") <= 10) {
                dateRange = {
                    start: start.clone().startOf("day"),
                    end: end.clone().endOf("day")
                };
            }
            else {
                dateRange = {
                    start: start.clone().startOf("day"),
                    end: start.clone().endOf("day")
                };
            }

            setRange(3);
            setPickerDate(dateRange);
            onChange(3, dateRange);
        }
    }, [enabledDate]);

    const enabledDateWithMoment = enabledDate && enabledDate.start && enabledDate.end ? {
        start: moment(enabledDate.start),
        end: moment(enabledDate.end)
    } : null;

    const syncSearchParamDate = () => {
        let dateRange = {};
        if (searchParams && (searchParams.from && searchParams.to)) {
            const start = moment(searchParams.from);
            const end = moment(searchParams.to);
            const diff = end.diff(start, "days");
            const now = moment.utc().tz(timezone);
            const todayDiff = now.diff(start, "days");

            if (diff <= 10) dateRange = { start, end };
            else dateRange = { start, end: moment(start).add(10, "days").endOf('days') }

            if (diff !== 0 && todayDiff === 1) setRange(3);
            else todayDiff === 0 ? setRange(1) : todayDiff === 1 ? setRange(2) : setRange(3);
            setPickerDate(dateRange);
            onChange(3, dateRange);
        }
    }

    const recentSummaryDate = (start_date, end_date) => {
        let dateRange = {};
        let range = 3;
        if (start_date && end_date) {
            dateRange.start = moment(start_date).startOf("day");
            dateRange.end = moment(end_date).endOf('days');
            range = 3;
        } else {
            const today = moment.utc().tz(timezone).format(API_DATETIME_FORMAT);
            dateRange.start = moment.utc(today).startOf("day");
            dateRange.end = moment.utc(today).endOf("day");
            range = 1;
        }

        setRange(range);
        setPickerDate(dateRange);
        onChange(range, dateRange);
    }

    return (<>
        <div className="dropdown dropup dropdown-calendar">
            <div className={`dropdown-menu ${showCalendar ? "show" : ""}`}>
                <DatePicker
                    maxSelectDays={maxSelectDays}
                    enabledDate={enabledDateWithMoment}
                    selectedDate={pickerDate}
                    onChange={dateRange => {
                        setPickerDate(dateRange);
                    }} onReset={() => {
                        const date = getInitialDate();
                        setPickerDate(date);
                        onChange(3, date);
                    }} onDone={() => {
                        toggleCalendar(!showCalendar);
                        onChange(3, pickerDate);
                    }} />
            </div>
        </div>
        <ButtonGroupToggle
            className="range-selection"
            value={range}
            onSelect={range => handleRangeSelect(range)}
            options={[
                { value: 3, label: <i className="fa fa-calendar" /> },
                { value: 2, label: "Yesterday" },
                { value: 1, label: "Today" }
            ]} />
    </>);
}

const DatePicker = props => {
    const { selectedDate: { start, end }, maxSelectDays, enabledDate, onChange, onDone, onReset } = props;
    const { from, to } = { from: start ? start.toDate() : start, to: end ? end.toDate() : end };
    const modifiers = { start: from, end: to };

    const maxDays = { from: moment(new Date(2011, 0)), to: moment(new Date(2050, 0)) };
    const disabledDays = enabledDate && enabledDate.start && enabledDate.end ?
        [{ from: maxDays.from.toDate(), to: enabledDate.start.clone().subtract(1, "day").toDate() },
        { from: enabledDate.end.clone().add(1, "day").toDate(), to: maxDays.to.toDate() }] :
        [{ from: moment().add(1, "day").toDate(), to: maxDays.to.toDate() }];

    return <div className="range-picker">
        {maxSelectDays > 1 ?
            <>
                <div className="range-picker-title">
                    {!from && !to && 'Please select the first day.'}
                    {from && !to && 'Please select the last day.'}
                    {from && to && `${start.format(DISPLAY_DATE_FORMAT2)} to ${end.format(DISPLAY_DATE_FORMAT2)}`}
                </div>
                <div className="range-picker-calendar">
                    <DayPicker fixedWeeks
                        className="Selectable"
                        month={from}
                        numberOfMonths={1}
                        disabledDays={disabledDays}
                        selectedDays={[from, { from, to }]}
                        modifiers={modifiers}
                        onDayClick={(day, { disabled }) => {
                            if (disabled) return;
                            if (day && !DateUtils.isDayBetween(day, maxDays.from.toDate(), maxDays.to.toDate())) return;

                            const date = DateUtils.addDayToRange(day, { from, to });
                            if (date.from && date.to) {
                                const timeDiff = Math.abs(date.to.getTime() - date.from.getTime());
                                const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1;
                                if (diffDays > maxSelectDays) {
                                    let start = moment(date.from);
                                    let end = moment(date.to);

                                    if (from && date.from.toISOString() !== from.toISOString())
                                        end = start.clone().add(maxSelectDays - 1, "days");
                                    else
                                        start = end.clone().subtract(maxSelectDays - 1, "days");

                                    return onChange({ start: start.startOf("day"), end: end.endOf("day") });
                                }
                            }

                            const start = date.from ? moment(date.from).startOf("day") : undefined;
                            const end = date.to ? moment(date.to).endOf("day") : undefined;
                            onChange({ start, end });
                        }}
                    />
                </div>
                <div className="d-flex px-2">
                    <div className="flex-fill py-2 px-1">
                        <Button className="w-100" variant="danger" size="sm" disabled={from ? false : true}
                            onClick={onReset}>Reset</Button>
                    </div>
                    <div className="flex-fill py-2 px-1">
                        <Button className="w-100" variant="primary" size="sm" disabled={from && to ? false : true}
                            onClick={onDone}>Done</Button>
                    </div>
                </div>
            </> :
            <>
                <div className="range-picker-title">
                    {from ? start.format(DISPLAY_DATE_FORMAT2) : 'Please select a day'}
                </div>
                <div className="range-picker-calendar">
                    <DayPicker fixedWeeks
                        month={from}
                        selectedDays={from}
                        onDayClick={(day, { selected }) => {
                            const selectedDay = selected ? undefined : moment.utc(day);
                            return onChange({ start: selectedDay, end: selectedDay ? selectedDay.clone().endOf("day") : selectedDay });
                        }}
                    />
                </div>
            </>}
    </div>;
}

const mapStateToProps = state => ({
    searchParams: state.analyze.searchParams.custom,
    recentSummary: state.analyze.recentSummary
});

export default connect(mapStateToProps, null)(RangeSelection);